/* ENDQUOTE — Road to Champion visibility (2026-09-20).
   Surfaces the live automatic Matchwear volume discount (2 outfits = 10% off,
   3 = 15%, 5 = 25%) where customers actually see it:
     - a banner on the Matchwear and Road to Champion collection pages;
     - a note near the buy button on Matchwear product pages.
   The discount itself is a real automatic discount in Shopify; this only announces
   it. Self-contained: injects its own CSS, detects Matchwear via the product's own
   JSON (/products/<handle>.js), touches no core theme file. Loaded via a <script>
   tag in snippets/meta-tags.liquid. Revert: delete this file + its tag. */
(function () {
	var path = location.pathname;
	var isCollection = /\/collections\/(matchwear|road-to-champion)(\/|$|\?)/.test(path);
	var isProduct = /\/products\//.test(path);
	if (!isCollection && !isProduct) return;

	injectCSS();

	if (isCollection) {
		ready(placeBanner);
		return;
	}

	// Product page: only show the note on Matchwear products.
	var m = path.match(/\/products\/([^/?#]+)/);
	if (!m) return;
	fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
		.then(function (r) { return r.ok ? r.json() : null; })
		.then(function (p) { if (p && p.type === 'Matchwear') ready(placeNote); })
		.catch(function () {});

	function ready(fn) {
		if (document.readyState !== 'loading') fn();
		else document.addEventListener('DOMContentLoaded', fn);
	}

	function placeBanner() {
		if (document.querySelector('.eq-rtc-banner')) return;
		var d = document.createElement('div');
		d.className = 'eq-rtc-banner';
		d.innerHTML =
			'<span class="eq-rtc-banner__label">Road to Champion</span>' +
			'<span class="eq-rtc-banner__text">Build your kit and the saving comes off at checkout on its own. ' +
			'Two outfits 10% off, three 15%, five 25%.</span>';
		var grid = document.querySelector(
			'#product-grid, .product-grid, .collection__products, .facets-wrapper, .collection-products, .collection'
		);
		if (grid && grid.parentNode) grid.parentNode.insertBefore(d, grid);
		else {
			var main = document.querySelector('#MainContent, main');
			if (main) main.insertBefore(d, main.firstChild);
		}
	}

	function placeNote() {
		if (document.querySelector('.eq-rtc-note')) return;
		var n = document.createElement('div');
		n.className = 'eq-rtc-note';
		n.innerHTML =
			'<strong>Road to Champion.</strong> Buy more of the match line and it comes off automatically ' +
			'at checkout: two outfits 10% off, three 15%, five 25%. ' +
			'<a href="/collections/road-to-champion">Build the kit.</a>';
		var anchor = document.querySelector(
			'.product-form, form[action*="/cart/add"], [id^="product-form"], product-form'
		);
		if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(n, anchor);
		else {
			var info = document.querySelector(
				'.product__info-container, .product__info, .product-section .product__info, .product-section'
			);
			if (info) info.appendChild(n);
		}
	}

	function injectCSS() {
		if (document.getElementById('eq-rtc-css')) return;
		var s = document.createElement('style');
		s.id = 'eq-rtc-css';
		s.textContent =
			'.eq-rtc-banner{display:flex;flex-wrap:wrap;align-items:baseline;gap:4px 14px;margin:0 0 20px;padding:13px 16px;border:1px solid;border-color:color-mix(in srgb,currentColor 22%,transparent);border-radius:4px}' +
			'.eq-rtc-banner__label{font-size:11px;letter-spacing:.18em;text-transform:uppercase;font-weight:700}' +
			'.eq-rtc-banner__text{font-size:13.5px;line-height:1.45;opacity:.82}' +
			'.eq-rtc-note{margin:14px 0;padding:11px 14px;border:1px solid;border-color:color-mix(in srgb,currentColor 20%,transparent);border-left:3px solid #0B3D2E;border-radius:4px;font-size:13px;line-height:1.5}' +
			'.eq-rtc-note strong{letter-spacing:.02em}' +
			'.eq-rtc-note a{color:inherit;text-decoration:underline}' +
			'html[data-scheme="dark"] .eq-rtc-note{border-left-color:#7fae99}';
		(document.head || document.documentElement).appendChild(s);
	}
})();
